import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';

import {
  MAT_DIALOG_DATA,
  MatDialogRef, MatSnackBar
} from '@angular/material';
import {
  UserContext
} from '../../services/user-context/user-context';
import {ApiService} from "../../services/api/api.service";
import * as moment from 'moment';

@Component({
  selector: 'app-prescription-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'prescription-dialog.template.html'
})

export class PrescriptionDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    name: '',
    date: '',
    expires: '',
    description: '',
    quantity: '',
    instructions: '',
    refillsCount: 0,
    refillsExpire: '',
    hasRefills: false,
  };

  expires: Date;
  refillsExpire: Date;
  public templates: Array<string> = [ "Orthotics", "Compression Wear", "Pain Management" ];
  public selectedTemplate: string;

  public validationMessages = {
    name: {minlength: 'Minimum 2 characters', required: 'Name required'},
    description: {minlength: 'Minimum 2 characters', required: 'Description required'},
    quantity: {minlength: '1', required: 'Quantity required'}
  };

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<PrescriptionDialogComponent>,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public session: any) {

    this.expires = moment(moment().add(2, 'month').toISOString()).toDate();
    this.refillsExpire = moment(moment().add(12, 'month').toISOString()).toDate();
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      name: new FormControl({value:this.session.consumer.subject, disabled: false}, [
        Validators.required,
        Validators.minLength(2)
      ]),
      date: new FormControl(new Date(), [
        Validators.required
      ]),
      expires: new FormControl(this.expires, [
        Validators.required
      ]),
      description: new FormControl('', [
        Validators.required,
        Validators.minLength(2)
      ]),
      quantity: new FormControl('', [
        Validators.required,
        Validators.minLength(1)
      ]),
      instructions: new FormControl('', []),
      hasRefills: new FormControl(false, []),
      refillsCount: new FormControl(0, []),
      refillsExpire: new FormControl(this.refillsExpire, []),
    });

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public templateChanged(value: string): void {
    console.log("Template changed to " + value);
    if (value === 'Orthotics') {
      this.form.controls["description"].setValue("Orthotics");
      this.form.controls["quantity"].setValue("1 Pair");
      this.form.controls["instructions"].setValue("Install orthotic appliance in footwear for everyday use.");
    } else if (value === 'Compression Wear') {
      this.form.controls["description"].setValue("Compression Socks");
      this.form.controls["quantity"].setValue("2 Pair");
      this.form.controls["instructions"].setValue("Wear compression socks for everyday use.");
    } else if (value === 'Pain Management') {
      this.form.controls["description"].setValue("CBD Tincture");
      this.form.controls["quantity"].setValue("60ml");
      this.form.controls["instructions"].setValue("Take 5 ml daily");
    }
  }

  public onValueChanged(data?: any): void {
    if (!this.form) { return; }
    const form = this.form;

    for ( const field of Object.keys( this.formErrors) ) {
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];

        for ( const key of Object.keys( control.errors ) ) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  public save(value: any) {
      const prescription = {
        name: this.form.value.name,
        date: this.form.value.date,
        expires: this.form.value.expires,
        description: this.form.value.description,
        quantity: this.form.value.quantity,
        instructions: this.form.value.instructions,
        refillsCount: this.form.value.refillsCount,
        refillsExpire: this.form.value.refillsExpire,
        hasRefills: this.form.value.hasRefills,
      };
      this.dialogRef.close(prescription);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
